/** Service Desk console: Tickets list and views, New ticket (C01, SD-S1-43). Copy follows mockups/tickets/tickets.html. */
export const serviceTickets = {
  subtitle: "Everything your clients have asked for, in one queue. Pick a view, filter, and work down the list with",
  newTicket: "New ticket",
  loading: "Loading tickets",
  noOrganisation: "No organisation",
  unassigned: "Unassigned",
  units: { minute: "min", hour: "h", day: "d" },
  sla: { pausedWaiting: "waiting for client", pausedOnHold: "on hold" },
  views: {
    label: "Ticket views",
    title: "Views",
    saved: "Saved views",
    shared: "Shared",
    unassigned: "Unassigned",
    my_open: "My open",
    my_team: "My team",
    teamNamed: "My team ({{name}})",
    waiting_client: "Waiting for client",
    breaching_soon: "Breaching soon",
    all_open: "All open",
    resolved: "Resolved",
    closed: "Closed",
    note: "Counts are computed from the tickets you can see.",
    delete: "Delete view {{name}}",
    deleted: "View “{{name}}” deleted",
  },
  search: {
    label: "Search tickets",
    placeholder: "Search number, title, organisation, requester…",
    clear: "Clear search",
  },
  filters: {
    button: "Filters",
    title: "Filter tickets",
    active_one: "{{count}} filter on",
    active_other: "{{count}} filters on",
    clearAll: "Clear all",
    status: "Status",
    priority: "Priority",
    type: "Type",
    team: "Team",
    assignee: "Assignee",
    organisation: "Organisation",
    tag: "Tag",
    anyStatus: "Any status",
    anyPriority: "Any priority",
    anyType: "Any type",
    anyTeam: "Any team",
    anyone: "Anyone",
    anyOrganisation: "Any organisation",
    me: "Me",
    remove: "Remove filter {{filter}}",
    lockedByView: "Set by the “{{view}}” view",
  },
  columnsButton: "Columns",
  columnsLabel: "Visible columns",
  columnsReset: "Reset",
  columnsAlways: "(always)",
  columns: {
    number: "Ticket",
    title: "Title",
    org: "Organisation",
    requester: "Requester",
    type: "Type",
    status: "Status",
    priority: "Priority",
    assignee: "Assignee",
    sla: "SLA",
    updated: "Updated",
    created: "Created",
  },
  table: {
    label: "Tickets",
    selectAll_one: "Select the {{count}} loaded ticket",
    selectAll_other: "Select all {{count}} loaded tickets",
    select: "Select {{number}}",
    focused: "{{number}}, {{position}} of {{count}}",
  },
  foot: {
    showing_one: "Showing {{shown}} of {{total}} ticket",
    showing_other: "Showing {{shown}} of {{total}} tickets",
    sorted: "sorted by {{column}} ({{order}})",
    asc: "ascending",
    desc: "descending",
    loadMore: "Load more",
  },
  bulk: {
    label: "Bulk actions",
    selected_one: "{{count}} selected",
    selected_other: "{{count}} selected",
    assign: "Assign",
    assignMe: "Assign to me",
    unassign: "Unassign",
    status: "Status",
    statusHint: "Move to",
    priority: "Priority",
    addTag: "Add tag",
    tagLabel: "Tag",
    applyTag: "Add to tickets",
    merge: "Merge",
    mergeHint: "Select exactly two open tickets from the same organisation to merge",
    clear: "Clear",
    done_one: "Updated {{count}} ticket",
    done_other: "Updated {{count}} tickets",
    partial: "Updated {{changed}}. {{skipped}} skipped (not a valid move from where they are), {{failed}} could not be changed.",
  },
  empty: {
    clear: "Clear filters",
    filteredTitle: "No tickets match these filters",
    filteredHint: "Try removing a filter or searching for something else.",
    unassigned: { title: "Nothing waiting for an owner", hint: "Every open ticket has someone on it." },
    my_open: { title: "No open tickets assigned to you", hint: "Take one from Unassigned, or check your team view." },
    my_team: { title: "Your team queue is clear", hint: "No open tickets for your team right now." },
    waiting_client: { title: "Nobody is waiting on a client", hint: "Tickets you set to Waiting for client show up here." },
    breaching_soon: { title: "No tickets breaching soon — nice.", hint: "Tickets near their SLA limit appear here, most urgent first." },
    all_open: { title: "No open tickets", hint: "New tickets from the widget, e-mail and Messenger land here." },
    resolved: { title: "No resolved tickets", hint: "Resolved tickets stay here until the client confirms or they auto-close." },
    closed: { title: "No closed tickets", hint: "Closed and cancelled tickets are kept for reporting." },
    saved: { title: "Nothing in this view yet", hint: "No tickets match this saved view right now." },
  },
  error: { title: "We couldn't load your tickets", body: "Something went wrong on our side. Please try again." },
  saveView: {
    button: "Save view",
    title: "Save this view",
    name: "Name",
    placeholder: "e.g. Water systems this week",
    nameShort: "Enter a name of at least {{min}} characters.",
    share: "Share with my team ({{team}})",
    shareHint: "Personal by default. Teammates see a shared view in their rail.",
    summary_one: "Saves {{count}} filter on top of the “{{view}}” view.",
    summary_other: "Saves {{count}} filters on top of the “{{view}}” view.",
    summarySearch: "The search “{{q}}” is saved too.",
    cancel: "Cancel",
    save: "Save view",
    saved: "View “{{name}}” saved",
  },
  shortcuts: {
    button: "Shortcuts",
    title: "Keyboard shortcuts",
    hint: "They work when you are not typing in a field.",
    next: "Next ticket",
    prev: "Previous ticket",
    open: "Open the ticket",
    select: "Select or unselect the ticket",
    reply: "Reply to the client",
    note: "Add an internal note",
    assign: "Assign",
    status: "Change status",
    macro: "Insert a macro",
    new: "New ticket",
    search: "Search the list",
    help: "Show this list",
    clear: "Clear the selection",
  },
  new: {
    assetPicker: {
      needsOrganisation: "Choose the requester first: the equipment offered is the requester's organisation's own.",
      search: "Search the organisation's equipment",
      searchLabel: "Search equipment",
      error: "The equipment couldn't load. Try again.",
      notListed: "Not listed",
      narrow: "Showing {{shown}} of {{total}}. Type to narrow the list.",
      linkFailed: "The ticket was created, but the equipment could not be linked to it.",
    },
    dialogTitle: "New ticket",
    dialogHint: "Created on behalf of a client (phone call, walk-in or forwarded e-mail). Routing rules assign it like any other ticket.",
    requester: "Requester",
    requesterHint: "Search by name or e-mail.",
    requesterPlaceholder: "Search contacts…",
    contactResults: "Matching contacts",
    contactNone: "No contact matches. Add them as a new contact below.",
    contactError: "Contacts could not be loaded. You can add the person as a new contact instead.",
    changeContact: "Change",
    addNew: "Add a new contact",
    useExisting: "Choose an existing contact",
    newName: "Name",
    newEmail: "E-mail",
    newEmailHint: "Optional. Without it the client cannot be notified.",
    organisation: "Organisation",
    type: "Type",
    priority: "Priority",
    title: "Title",
    titleHint: "A short, specific summary. The client sees this title.",
    titlePlaceholder: "What is the problem or request?",
    description: "Description",
    descriptionPlaceholder: "What the client told you. Paste the e-mail or add your call notes.",
    assignee: "Assign to",
    autoRoute: "Auto-route (routing rules decide)",
    routingGeneric: "Routing rules will assign this ticket to a team or person when it is created.",
    routingRule: "Rule #{{number}} {{name}} → {{where}}.",
    routingQueue: "team queue",
    notify: "Send the client a confirmation e-mail",
    notifyHint: "Staff-created tickets notify the client only when this is ticked.",
    cancel: "Cancel",
    create: "Create ticket",
    created: "Ticket {{number}} created",
    typesError: "Ticket types could not be loaded",
    noTypes: "No ticket type is available for client requests yet. Ask an administrator to switch one on in Service settings.",
    errors: {
      requester: "Choose who this ticket is for.",
      newName: "Enter the person's name.",
      newEmail: "Enter a valid e-mail address.",
      type: "Choose a type.",
      title: "Enter a title of at least {{min}} characters.",
      field: "This field is required.",
    },
  },
  live: { connecting: "Connecting", live: "Live", reconnecting: "Reconnecting" },
  export: {
    button: "Export CSV",
    done: "Exported {{count}} tickets to {{file}}",
    truncated: "The file holds the first 10,000 tickets. Narrow the view with a filter to export the rest.",
    widened: "Your filters were too long to send, so the whole view was exported.",
  },
} as const;
